module.exports = __webpack_public_path__ + "static/media/ic_已选.28960d25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_已选.svg
// module id = 253
// module chunks = 0